import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import { getImage } from '../../utils/FileHelper';

import WebViewer from '@pdftron/pdfjs-express-viewer';
import ReactPlayer from 'react-player';
import { canPdfPreview } from '../../utils/FileTypeHelpers';
import { ArrowUturnLeftIcon } from '@heroicons/react/24/outline';

/**
 *
 * @param attachment
 * @param id
 * @param url
 * @param open
 * @param setOpen
 * @returns {JSX.Element}
 * @constructor
 */
const ResourceView = ({ attachment, id, url, open, setOpen }) => {
	const cancelButtonRef = useRef(null);
	const navigate = useNavigate();
	const viewer = useRef(null);

	useEffect(() => {
		if (attachment.extension === 'mp4') {
			console.log('not pdf'); // zzmatt
		} else {
			WebViewer(
				{
					path: '/webviewer/lib',
					initialDoc: url,
					licenseKey: 'UiFIk6idSBsJFsurD1ES',
					setToolbarControl: false,
				},
				viewer.current,
			).then(instance => {
				// now you can access APIs through the WebViewer instance
				const { Core } = instance;
				instance.UI.disableElements(['panToolButton']);
				instance.UI.disableElements(['selectToolButton']);
				instance.UI.disableElements(['panelToolButton']);
				instance.UI.disableElements(['leftPanelButton']);
				instance.UI.disableElements(['toolbarGroup-Shapes']);
				instance.UI.disableElements(['toolbarGroup-Edit']);
				instance.UI.disableElements(['toolbarGroup-Insert']);

				instance.UI.disableElements(['ribbons']);

				instance.UI.setHeaderItems(header => {
					header.getHeader('default').unshift({
						img: 'icon-chevron-left',
						index: -1,
						type: 'actionButton',
						element: 'fullScreenButton',
						title: 'Back',
						onClick: () => {
							handleClose();
						},
					});
				});

				instance.UI.setTheme('dark');
			});
		}
	}, []);

	function handleClose() {
		setOpen(false);
		navigate(-1);
	}

	return (
		<Transition.Root show={open} as={Fragment}>
			<Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0">
					<div className="fixed inset-0 bg-black bg-opacity-80 transition-opacity" />
				</Transition.Child>

				<div className="fixed inset-0 z-10 overflow-y-auto">
					<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-start sm:p-0">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
							<div className="w-full h-screen">
								{canPdfPreview(attachment.extension) ? (
									<div className="webviewer" ref={viewer}></div>
								) : (
									<div>
										<div className="pb-4" onClick={handleClose}>
											<span className="text-white">
												<ArrowUturnLeftIcon className="h-6 w-6 text-white" />
											</span>
										</div>
										<ReactPlayer
											url={url}
											controls="true"
											width="100%"
											height="100%"
											muted="true"
										/>
									</div>
								)}
							</div>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	);
};

const PDFPreviewPage = ({ attachment, attachmentId, open, setOpen }) => {
	const [pdfUrl, setPdfUrl] = useState(null);

	useEffect(() => {
		getImage({ id: attachmentId, resourceId: attachmentId, setImgUrl: setPdfUrl });
	}, [attachmentId]);

	if (!pdfUrl) {
		return <div>Loading PDF</div>;
	}

	return <ResourceView attachment={attachment} url={pdfUrl} id={attachmentId} open={open} setOpen={setOpen} />;
};
export default PDFPreviewPage;
